import { FutureEntriesIndicatorTranslations } from "./future-entries-indicator-pt-br";

export const FUTURE_ENTRIES_INDICATOR_EN_US: FutureEntriesIndicatorTranslations = {
	futureEntries: "Future entries for the next",
	days: "{{count}} days",
	viewFutureEntries: "View Future Entries",
	futureEntriesTooltip:
		"Expected amounts, such as receivables and charges that are due soon or that are pending due to insufficient funds.",
};
